var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[(_vm.ready && _vm.user.id)?_c('MainArea'):(_vm.ready || !_vm.haveLoggedIn)?_c('LandingPage'):_c('LoadingPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }